import './UserSettingsModal.scss'
import React from 'react'
import { getCancelSource } from 'misc/api/util'
import { SettingsModalContent } from 'components/Modals/UserSettingsModal/View'

import API from 'misc/api'

class UserSettingsModal extends React.Component {
  constructor(props) {
    super(props)

    this.available_languages = this.props.available_languages
    this.available_timezones = this.props.available_timezones
    this.available_countries = this.props.available_countries

    this.flat_countries_list = this.extractCountries()
    this.state = {
      submitting: false,
      language: this.getLanguageByLangCode(this.props.langCode),
      country: this.props.country,
      city: this.props.city
    }
  }

  apiRequest = null
  cancelSource = getCancelSource()

  extractCountries = () => {
    let countries = []

    // Loop through each entry in the available_countries object
    for (const [key, countryObj] of Object.entries(this.available_countries)) {
      // Extract the local_name and add it to the countries array
      if (countryObj && countryObj.local_name) {
        countries.push(countryObj.local_name)
      }
    }

    // Optional: Sort the countries alphabetically
    countries.sort()

    return countries
  }

  getLanguageByLangCode = langCode => {
    let lang = ''

    for (const [key, langObj] of Object.entries(this.available_languages)) {
      if (langCode === key) {
        lang = langObj.local_language_name
      }
    }

    return lang
  }

  extractLanguageNames = () => {
    let languages = []
    for (const [key, langObj] of Object.entries(this.available_languages)) {
      languages.push(langObj.local_language_name)
    }

    return languages
  }

  handleUpdateLanguageAndTimezone = () => {
    const { language, city } = this.state

    this.setState({ submitting: true })

    let selected_timezone = ''
    for (const [key, object] of Object.entries(this.available_timezones)) {
      if (object.local_exemplar_city_name === city) {
        selected_timezone = key
        break
      }
    }

    let language_code = ''
    for (const [code, object] of Object.entries(this.available_languages)) {
      if (object.local_language_name === language) {
        language_code = code
        break
      }
    }

    console.log(
      `Submitting settings to backend... (${language_code}, ${selected_timezone})`
    )

    this.apiRequest = API.postUserTimezoneLanguageSettings(
      {
        language: language_code,
        timezone: selected_timezone
      },
      this.cancelSource.token
    )
      .then(response => {
        if (response.status === 200) {
          // TODO: Update organization provider
          // this.setState({ eventId: response.data.event })
        }
      })
      .catch(error => console.error(error))
      .finally(() => {
        window.location.reload()
      })
    this.props.handleClose()
  }

  getAvailableCities = () => {
    const { country } = this.state
    const cities = []
    var country_code = ''
    for (const [key, object] of Object.entries(this.available_countries)) {
      if (object.local_name === country) {
        country_code = object.code
      }
    }

    for (const [key, object] of Object.entries(this.available_timezones)) {
      if (object.country_code === country_code) {
        cities.push(object.local_exemplar_city_name)
      }
    }
    return cities
  }

  handleLanguageChange = changeEvent => {
    // debugger;
    // const {value: language} = changeEvent
    this.setState({ language: changeEvent })
    console.log('Changing language to: ' + changeEvent + '...')
  }

  handleCountryChange = changeEvent => {
    // const { value: country } = changeEvent.target
    this.setState({ country: changeEvent, city: '' })
    console.log('Changing country to: ' + changeEvent + '...')
  }

  handleCityChange = changeEvent => {
    // const { value: city } = changeEvent.target
    this.setState({ city: changeEvent })
    console.log('Changing city to: ' + changeEvent + '...')
  }

  componentDidMount() {
    // TODO: Make request to fetch available langs and country/city
    // this.apiRequest = API.getOrganizationSettings(this.cancelSource.token)
    //     .then(response => {
    //         const templates = response.data
    //         this.setState({templates})
    //         this.apiRequest = null
    //     })
    //     .catch(error => console.error(error))
    console.log('UserSettingsModal: componentDidMount')
  }

  componentWillUnmount() {
    if (this.apiRequest) {
      this.cancelSource.cancel()
    }
  }

  render() {
    const { handleClose } = this.props
    const { language, country, city, submitting } = this.state
    return (
      <SettingsModalContent
        language={language}
        country={country}
        city={city}
        available_languages={this.extractLanguageNames()}
        available_countries={this.flat_countries_list}
        available_timezones={this.available_timezones}
        getAvailableCities={this.getAvailableCities}
        submitting={submitting}
        handleClose={handleClose}
        handleUpdateLanguageAndTimezone={this.handleUpdateLanguageAndTimezone}
        handleLanguageChange={this.handleLanguageChange}
        handleCountryChange={this.handleCountryChange}
        handleCityChange={this.handleCityChange}
      />
    )
  }
}

export default UserSettingsModal
